import controlArrows from "./controlArrows.js";
import createDays from "./createDays.js";
import createDOM from "./createDOM.js";
import showMonth from "./showMonth.js";
import showYear from "./showYear.js";
import createMonths from "./createMonths.js";
import createTime from "./createTime.js";
import createWeek from "./createWeek.js";
import createYears from "./createYears.js";
import getLocale from "./getLocale.js";
import setTheme from "./setTheme.js";
const mainMethod = (self) => {
  setTheme(self);
  getLocale(self);
  createDOM(self);
  showMonth(self);
  showYear(self);
  controlArrows(self);
  createTime(self);
  if (self.currentType === "default" || self.currentType === "multiple") {
    createWeek(self);
    createDays(self);
  } else if (self.currentType === "month") {
    createMonths(self);
  } else if (self.currentType === "year") {
    createYears(self);
  }
};
export {
  mainMethod as default
};
